<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>

           <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>
        <br />

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getData()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>
        <br />

        <v-col cols="12" class="pa-2 ma-2">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportData()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>

          <!-- data table -->
          <v-col cols="12" >

            <v-card elevation="7" v-if="dataReady">
               <v-alert
             v-if="dataReady"
              dense
              outlined
              type="error"
            >
              รายชื่อพนักงาน <strong> รอดำเนินการ</strong>
            </v-alert>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.empHelpChoice`]="{ item }">
                    <v-chip
                          v-if="item.empHelpChoice === 'True'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                         ใช่
                        </v-chip>
                    <v-chip
                          v-if="item.empHelpChoice === null"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                         ไม่
                        </v-chip>
                  </template>
                  <template v-slot:[`item.empHelpChoice1`]="{ item }">
                    <v-chip
                          v-if="item.empHelpChoice1 === 'True'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                         ใช่
                        </v-chip>
                    <v-chip
                          v-if="item.empHelpChoice1 === null"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                         ไม่
                        </v-chip>
                  </template>
                  <template v-slot:[`item.empHelpChoice2`]="{ item }">
                    <v-chip
                          v-if="item.empHelpChoice2 === 'True'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                         ใช่
                        </v-chip>
                    <v-chip
                          v-if="item.empHelpChoice2 === null"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                         ไม่
                        </v-chip>
                  </template>
                  <template v-slot:[`item.empHelpStatus`]="{ item }">
                    <v-chip
                          v-if="item.empHelpStatus === 'draft'"
                          class="ma-2"
                          color="amber "
                          text-color="white"
                        >
                         รอดำเนินการ
                        </v-chip>
                  </template>
                  <template v-slot:[`item.Approve`]="{ item }">
                    <v-btn
                      v-if="item.empHelpStatus === 'draft'"
                      color="blue"
                      fab
                      small
                      dark
                      @click.stop="updateStatus(item)"
                    >
                      <v-icon dark> mdi-account-check </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.View`]="{ item }">
                    <v-btn
                      color="success"
                      fab
                      small
                      @click.stop="(dialog = true), getByEmp(item)"
                    >
                      <v-icon dark> mdi-map-marker </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.Delete`]="{ item }">
                    <v-btn
                      color="red"
                      fab
                      dark
                      small
                      @click.stop="deleteData(item)"
                    >
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>

            <v-card elevation="7" v-if="dataReady">
                <v-alert
              v-if="dataReady"
                dense
                text
                type="success"
              >
                  รายชื่อพนักงาน <strong> ดำเนินการเรียบร้อยแล้ว</strong>
              </v-alert>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItemComplete"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.empHelpChoice`]="{ item }">
                    <v-chip
                          v-if="item.empHelpChoice === 'True'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                         ใช่
                        </v-chip>
                    <v-chip
                          v-if="item.empHelpChoice === null"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                         ไม่
                        </v-chip>
                  </template>
                  <template v-slot:[`item.empHelpChoice1`]="{ item }">
                    <v-chip
                          v-if="item.empHelpChoice1 === 'True'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                         ใช่
                        </v-chip>
                    <v-chip
                          v-if="item.empHelpChoice1 === null"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                         ไม่
                        </v-chip>
                  </template>
                  <template v-slot:[`item.empHelpChoice2`]="{ item }">
                    <v-chip
                          v-if="item.empHelpChoice2 === 'True'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                         ใช่
                        </v-chip>
                    <v-chip
                          v-if="item.empHelpChoice2 === null"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                         ไม่
                        </v-chip>
                  </template>
                  <template v-slot:[`item.empHelpStatus`]="{ item }">
                    <v-chip
                          v-if="item.empHelpStatus === 'done'"
                          class="ma-2"
                          color="amber "
                          text-color="white"
                        >
                        ดำเนินการเรียบร้อย
                        </v-chip>
                  </template>
                  <template v-slot:[`item.View`]="{ item }">
                    <v-btn
                      color="success"
                      fab
                      small
                      @click.stop="(dialog = true), getByEmp(item)"
                    >
                      <v-icon dark> mdi-map-marker </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.Delete`]="{ item }">
                    <v-btn
                      color="red"
                      fab
                      dark
                      small
                      @click.stop="deleteData(item)"
                    >
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
              <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>รายละเอียด</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-col cols="12">
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate>
                      <template v-slot:actions>
                        <v-icon color="#871B12">
                          mdi-account-circle-outline
                        </v-icon>
                      </template>
                      {{ dataByEmp.empFull_NameTH }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="4">
                              <v-card elevation="2">
                                <center>
                                  <v-avatar
                                    class="profile"
                                    style="margin-top: 10px"
                                    color="grey"
                                    size="164"
                                    rounded
                                  >
                                    <v-img :src="dataByEmp.empImageUrl"></v-img>
                                  </v-avatar>
                                </center>
                                <v-col>
                                  <v-card-text
                                    ><v-icon color="#871B12">mdi-account</v-icon
                                    ><strong>ชื่อ-นามสกุล: </strong
                                    >{{ dataByEmp.empFull_NameTH }}
                                  </v-card-text>
                                  <v-card-text>
                                    <v-icon color="#871B12">mdi-account</v-icon>
                                    <strong>หน่วยงาน: </strong
                                    >{{ dataByEmp.masDepartmentName }}
                                  </v-card-text>
                                  <v-card-text>
                                    <v-icon color="#871B12">mdi-account</v-icon>
                                    <strong>สาขา : </strong
                                    >{{ dataByEmp.masBranchName }}
                                  </v-card-text>
                                  <v-card-text
                                    ><v-icon color="#871B12">mdi-account-box</v-icon
                                    ><strong>รหัสพนักงาน : </strong
                                    >{{ dataByEmp.empCode }}</v-card-text
                                  >
                                </v-col>
                              </v-card>
                            </v-col>
                            <v-col cols="4">
                              <center>
                          <v-img
                            :lazy-src="dataByEmp.empHelpFiles"
                            max-height="500"
                            max-width="500"
                            :src="dataByEmp.empHelpFiles"
                          ></v-img>
                          <v-img
                            :lazy-src="dataByEmp.empHelpFiles2"
                            max-height="500"
                            max-width="500"
                            :src="dataByEmp.empHelpFiles2"
                          ></v-img>
                          <v-img
                            :lazy-src="dataByEmp.empHelpFiles3"
                            max-height="500"
                            max-width="500"
                            :src="dataByEmp.empHelpFiles3"
                          ></v-img>
                        </center>
                            </v-col>
                        <v-col cols="12">
                          <v-col>
                            <GmapMap
                              :center="center"
                              map-type-id="terrain"
                              ref="mapRef"
                              :zoom="zoom"
                              style="width: 100%; height: 600px"
                              :options="{ disableDefaultUI: true }"
                            >
                              <GmapMarker :position="center" />
                              <GmapMarker
                                v-for="(m, indexMap1) in dataByEmp.shifttemMapCheckIn"
                                :key="indexMap1"
                                :position="m.positionIn"
                                :clickable="true"
                                :icon="m.iconIn"
                                @click="openWindows(m)"
                              />
                              <GmapMarker
                                v-for="(
                                  m2, indexMap2
                                ) in dataByEmp.shifttemMapCheckout"
                                :key="indexMap2 + 'M2'"
                                :position="m2.positionOut"
                                :clickable="true"
                                :icon="m2.iconOut"
                                @click="openWindows2(m2)"
                              />
                              <gmap-info-window
                                  @closeclick="window_open=false"
                                  :opened="window_open"
                                  :position="infowindow_position"
                                  :options="{
                                    pixelOffset: {
                                      width: 0,
                                      height: -35
                                    }
                                  }"
                              >
                                  {{infowindow_detail}}
                              </gmap-info-window>
                            </GmapMap>
                          </v-col>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-card>
          </v-dialog>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/employee_help/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการขอความช่วยเหลือ',
          disabled: true,
          href: '/HRM/Special/SpecialRequestEmpHelp'
        }
      ],
      // End Menu Config
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'PL_', // Generate Code
      valid_add: true,
      valid_update: true,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 30 || 'Name must be less than 30 characters'
      ],
      numberRule: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) ||
          'Number has to be between 0 and 999'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ขอความช่วยเหลือ', value: 'empHelpRequest' },
        { text: 'อาหาร/เครื่องดื่ม', value: 'empHelpChoice', align: 'center' },
        { text: 'ยาสามัญ', value: 'empHelpChoice1', align: 'center' },
        { text: 'ที่พักอาศัยชั่วคราว', value: 'empHelpChoice2', align: 'center' },
        { text: 'อื่นๆ', value: 'empHelpDetail' },
        { text: 'Status', value: 'empHelpStatus', align: 'center' },
        { text: 'Approve', value: 'Approve', sortable: false, align: 'center' },
        { text: 'View', value: 'View', sortable: false, align: 'center' },
        { text: 'Delete', value: 'Delete', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dataItemComplete: [],
      export_data: [],
      dataByEmp: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'vaccineId', value: 'vaccineId' },
        { text: 'vaccineId', value: 'vaccineId' },
        { text: 'vaccineName', value: 'vaccineName' },
        { text: 'vaccineCategory', value: 'vaccineCategory' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],

      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      year: '',
      month: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,

      center: {},
      // End Config Import
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      loading3: false,
      zoom: 14,
      window_open: false,
      infowindow_position: {lat: 10, lng: 10.0},
      infowindow_detail: ''
    }
  },
  async mounted () {
    await this.getGetToken()
    await this.geolocate()
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    this.dataReady = false
    // Get Data
    this.getData()

    // await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
  },
  methods: {
    async getData () {
      await this.getDataWaiting()
      await this.getDataApprove()
    },
    geolocate () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.dataReady = true
          console.log('center : ', center)
          this.center = center
        },
        (error) => {
          console.log('error map :', error.message)
          alert('กรุณาเปิด location ของท่าน')
        }
      )
    },
    async getDataWaiting () {
      this.dataItem = []

      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      this.month = this.month ? this.month : null
      var monthSearch =
        this.month !== null
          ? '&empHelpMonth=' + this.getMonthThToINT(this.month)
          : ''

      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee_help/get?empHelpStatus=draft' +
            Company + Branch + Department + '&empHelpYear=' +
            this.year +
            monthSearch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItem = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataApprove () {
      this.dataItemComplete = []

      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      this.month = this.month ? this.month : null
      var monthSearch =
        this.month !== null
          ? '&empHelpMonth=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee_help/get?empHelpStatus=done' +
            Company + Branch + Department + '&empHelpYear=' +
            this.year +
            monthSearch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemComplete = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getByEmp (dt) {
      // let date = new Date()
      this.month = this.getMonthTh()
      this.year = moment().format('YYYY')
      dt.empImageUrl = this.DNS_IP + '/' + dt.empImageUrl
      this.dataReady = false
      this.dataByEmp = []
      this.getDataWaiting(dt)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            dt.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.dataReady = true
          dt.shifttemMapCheckIn = response.data
          dt.shifttemMapCheckout = response.data
          this.mapGetDataCheckIn(dt.shifttemMapCheckIn)
          this.mapGetDataCheckOut(dt.shifttemMapCheckout)
          this.dataByEmp = dt
          console.log('dt : ', this.dataByEmp)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    mapGetDataCheckIn (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInStartLat && shifttem.checkInStartLong) {
          var position = {
            lat: parseFloat(shifttem.checkInStartLat),
            lng: parseFloat(shifttem.checkInStartLong)
          }

          shifttem.iconIn =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fin.png?alt=media'
          shifttem.positionIn = position
          this.center = position
        }
      })
    },
    mapGetDataCheckOut (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInEndLat && shifttem.checkInEndLong) {
          var position = {
            lat: parseFloat(shifttem.checkInEndLat),
            lng: parseFloat(shifttem.checkInEndLong)
          }

          shifttem.iconOut =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fout.png?alt=media'
          shifttem.positionOut = position
          this.center = position
        }
      })
    },
    openWindows (m) {
      console.log('m', m)
      this.zoom = 19
      this.center = m.positionIn
      this.window_open = true
      this.infowindow_position = m.positionIn

      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nเข้างานเมื่อ ' + m.checkInStartStamp
      // this.panToMarker(this.center)
    },
    openWindows2 (m) {
      console.log('m2', m)
      this.zoom = 19
      this.center = m.positionOut
      this.infowindow_position = m.positionOut
      this.window_open = true
      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nออกงานเมื่อ ' + m.checkInEndStamp
      // this.panToMarker(this.center)
    },
    updateStatus (item) {
      item.LAST_USER = this.$session.getAll().data.userName
      // End Config User ทำรายการล่าสุด

      let ds = {
        empHelpStatus: 'done',
        LAST_USER: this.$session.getAll().data.userName
      }
      // End Debug
      // สำหรับ แก้ไขข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนแก้ไขล่าสุด
      //
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ดำเนินการ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + item.empHelpID,
              ds, {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'ดำเนินการ เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false
              // Load Data
              this.getData()
              this.getDataComplete()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData (item) {
      let ds = {
        LAST_USER: this.$session.getAll().data.userName
      }
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "delete/" + item.empHelpID,
              ds, {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false
              // Load Data
              this.getData()
              this.getDataComplete()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              // this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          // this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async exportData () {
      var tem1 = []
      var tem2 = []
      this.dataItem.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          รายการ: element.empHelpRequest,
          อาหารเครื่องดื่ม: element.empHelpChoice,
          ยาสามัญ: element.empHelpChoice1,
          ที่พักชั่วคราว: element.empHelpChoice2,
          รายละเอียด: element.empHelpDetail,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.empHelpStatus
        }
        tem1.push(s)
      })
      this.dataItemComplete.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          รายการ: element.empHelpRequest,
          อาหารเครื่องดื่ม: element.empHelpChoice,
          ยาสามัญ: element.empHelpChoice1,
          ที่พักชั่วคราว: element.empHelpChoice2,
          รายละเอียด: element.empHelpDetail,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.empHelpStatus
        }
        tem2.push(s)
      })
      var data = XLSX.utils.json_to_sheet(tem1)
      var approve = XLSX.utils.json_to_sheet(tem2)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รอดำเนินการ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, approve, 'ดำเนินการแล้ว') // sheetAName is name of Worksheet
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(wb, 'รายการขอรายการ(' + this.day + ' ' + this.month + ' ' + this.year + ').xls') // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Special/SpecialRequestEmpHelp.vue